import { SET_SISDEVIN, SELECT_SISDEVIN } from './types';

const initialState = {
	list: [],
	select: false,
};

const sisdevinReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SISDEVIN:
			return {
				...state,
				list: action.sisdevin,
			};
		case SELECT_SISDEVIN:
			return {
				...state,
				select: action.sisdevin,
			};
		default:
			return state;
	}
};

export default sisdevinReducer;
